'use client';

import { useEffect } from 'react';
import BrandSection from '@/new-cars/BrandSection';
import { NewCarsHero } from '@/new-cars/Hero';
import GeolocationModal from '@/new-cars/Modals/GeolocationModal';
import useRecordNewCarsFlowVisit from '~/hooks/new-cars/useRecordNewCarsFlowVisit';
import useTestDriveCenter from '~/hooks/new-cars/useTestDriveCenter';
import { NEW_CARS_FLOW_LEVELS } from '~/utilities/new-cars/newCarsFlowLevel';
import TdcHeader from './Tdc/TdcHeader';

export default function NewCarsLandingContainer() {
  useRecordNewCarsFlowVisit(NEW_CARS_FLOW_LEVELS.new);
  const testDriveCenter = useTestDriveCenter();
  const { sendCube } = testDriveCenter;

  // Brand grid: tell the paired cube display to show its "select a model"
  // screen with no make scoped yet (no-op when not paired).
  useEffect(() => {
    sendCube({ screen: 'selectModel', make: null });
  }, [sendCube]);

  return (
    <div className="mx-auto flex min-h-screen max-w-[1800px] flex-col bg-background-weak">
      {testDriveCenter.isActive && <TdcHeader />}
      <NewCarsHero />
      <div className="mx-auto w-full max-w-[1056px]">
        <BrandSection />
      </div>
      <GeolocationModal />
    </div>
  );
}
